import { useQuery } from '@tanstack/react-query';
import { getGameHistory } from 'services/scratcherService';

export function useGameHistory(
  storeId: string | null | undefined, 
  gameId: string | null | undefined,
  status: string = 'all'
) {
  return useQuery({
    queryKey: ['game-history', storeId, gameId, status],
    queryFn: () => getGameHistory(storeId!, gameId!, status),
    enabled: !!storeId && !!gameId
  });
}

